export default {
    steps: {
        product: {
            noticeTitle: 'Founder Guide Step Complete',
            subtitle: 'Way to go! You’ve added your first product.',
            ctaLabel: 'View Founder Guide',
            link: 'dashboard',
            secondaryCtaLabel: 'Add Another',
            secondaryLink: 'product.add'
        },
        page: {
            noticeTitle: 'Founder Guide Step Complete!',
            subtitle: 'Nice job! You’ve successfully generated pages.',
            ctaLabel: 'View Founder Guide',
            link: 'dashboard',
            secondaryCtaLabel: 'Add Another',
            secondaryLink: 'pages.add'
        },
        'editstore.landing': {
            noticeTitle: 'Founder Guide Assistant',
            subtitle: 'Customize any part of your store below to complete the next step.'
        },
        'editstore.edit': {
            noticeTitle: 'Founder Guide Step Complete!',
            subtitle: 'Nice job! You’ve personalized your storefront.',
            ctaLabel: 'View Founder Guide',
            link: 'dashboard'
        }
    },
    nextsteps: {
        product: {
            initialMessage: 'Add your products',
            initialMessageLink: 'product.add'
        },
        personalize: {
            initialMessage: 'Personalize your storefront',
            initialMessageLink: 'editstore.landing'
        },
        page: {
            initialMessage: 'Automatically generate pages',
            initialMessageLink: 'pages.list'
        },
        finalstep: {
            initialMessage: 'Let’s get you selling!',
            initialMessageLink: 'dashboard'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/nextStepNotice/founderGuideNextStep.data.js